import CategoryList from './CategoryList'

CategoryList.install = function install (Vue) {
  Vue.component(CategoryList.name, CategoryList)
}

export default CategoryList



// WEBPACK FOOTER //
// ./src/components/category-list/index.js